import type React from 'react';

import styles from './styles';

import { HintPopup } from '@cobliteam/base-components/src/HintPopup/HintPopup';

interface HintPopupWithLinkProps {
  children: React.ReactNode;
  link: string;
  hintText: React.ReactNode;
  placement: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top';
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const HintPopupWithLink = ({ children, link, hintText, placement }: HintPopupWithLinkProps) => {
  const linkText = (
    <a href={link} className={styles.linkText} target='_blank' rel='noopener noreferrer'>
      clique aqui
    </a>
  );

  const hintTitle = (
    <>
      {hintText}
      {linkText}.
    </>
  );

  return (
    <HintPopup title={hintTitle} arrow placement={placement} interactive>
      <span>{children}</span>
    </HintPopup>
  );
};

export default HintPopupWithLink;
